/** @typedef {{apiCall:DR.ApiCall,className:String,noTitle:Boolean,noSubtitle:Boolean,hasSubtitle:Boolean,pseudoType:String}} T.CaseStudies.Par */
T.CaseStudies = Class(
	/**
	 * @lends {T.CaseStudies#}
	 */
	{
		/**
		 * @param {string} type
		 * @param { T.CaseStudies.Par} par
		 */
		__construct(type, par = {}) {
			let key = type;
			if (par.pseudoType) {
				key = par.pseudoType;
			}
			let classNames = ['container'];
			if (par.className) {
				classNames.push(par.className);
			}
			this.node = mkE({
				tag: 'div',
				id: 't-case-studies',
				className: classNames.join(' '),
				els: [
					par.noTitle ? '' : {
						tag: 'h2',
						text: D.Lang.get(`case-studies.${key}.title`)
					},
					par.noSubtitle ? '' : (D.Lang.exists(`case-studies.${key}.underline`) || par.hasSubtitle) ? {//@todo refactor
						tag: 'p',
						className: 'underline',
						text: D.Lang.get(`case-studies.${key}.underline`)
					} : ''
				]
			});

			this._mGetCaseStudies = new DR.casestudies.GetAll();
			this._mGetCaseStudies.pg = 1;
			this._mGetCaseStudies.count = 10;
			this._mGetCaseStudies.section = type;
			this._mGetCaseStudies.select = [
				new DR.casestudies.select.Item().url().title().cover().coverMobile(),
				new DR.roadgames.select.Image().all()
			];
			this._mGetCaseStudies.onLoad = this._mGetCaseStudiesRe;
			this._mGetCaseStudies.onError = this._mGetCaseStudiesError;
			par.apiCall.addMethod(this._mGetCaseStudies);
		},

		_mGetCaseStudiesRe() {
			const re = this._mGetCaseStudies.re;
			if (!re.items.length) {
				this.remove();
				return;
			}
			const imageSet = function(item) {
				const dpi = window.devicePixelRatio;
				if (dpi <= 1) {
					return item.small;
				} else if (dpi > 1 && dpi <= 2) {
					return item.medium;
				} else {
					return item.large;
				}
			};
			let items = [];
			for (let i = 0, l = re.items.length; i < l; i++) {
				const item = re.items[i];
				items.push(
					mkE({
						tag: 'a',
						href: D.url(item.url),
						className: 'case-study',
						style: {
							backgroundImage: D.CSS.brMobile ? `url(${imageSet(item.coverMobile.image)})` : `url('${item.cover.image.large}')`
						},
						els: [
							{
								tag: 'h3',
								className: 'h2 title',
								text: item.title
							},
							{
								tag: 'div',
								className: 'button-container',
								els: [
									{
										tag: 'div',
										className: 'button button-turquoise',
										text: D.Lang.get('case-studies.slider.show_more')
									}
								]
							}
						]
					})
				);
			}
			this._glider = new T.Glider({
				content: items,
				withBullets: true,
				config: {
					type: 'carousel',
					startAt: 0,
					perView: 1,
					focusAt: 'center',
					dragThreshold: false,
					autoplay: 15000,
					peek: (function() {
						if (D.CSS.brTablet) {
							return {
								before: 16,
								after: 16
							};
						}
						return 0;
					})(),
					gap: 16
				}
			}).append(this.node);
		},

		_mGetCaseStudiesError() {
			this.remove();
		},

		onShow() {
			if (this._glider) {
				this._glider.onShow();
			}
		},

		onLeave() {
			if (this._glider) {
				this._glider.onLeave();
			}
		}
	},
	mkE.Base
);